export const ManagePeyments = () => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M14 2H2C1.2785 2 1 2.23687 1 3V13C1 13.7631 1.2785 14 2 14H14C14.7215 14 15 13.7631 15 13V3C15 2.23687 14.7215 2 14 2ZM13 12H3V8H13V12ZM13 6H3V4H13V6Z'
      fill='inherit'
    />
  </svg>
);
